import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ItemIndexEllipseComponent } from './item-index-ellipse.component';

@NgModule({
  declarations: [ItemIndexEllipseComponent],
  imports: [CommonModule],
  exports: [ItemIndexEllipseComponent],
})
export class ItemIndexEllipseModule {}
